<template>
  <section class="estimate-list">
    <div class="estimate-error" v-if="errorFlag && !loading">
      <p>正常にデータが取得できませんでした。<br>お手数ですが時間をあけて再度アクセスしていただくか、<br class="is-sp">お問い合わせください。</p>
    </div>

    <estimate-displacements
      v-if="!errorFlag && !loading"
      v-model:selectDisplacement="selectDisplacement"
    />
    <estimate-search-list-category
      v-if="!errorFlag && !loading"
      :displacement-bikes-list="filteredBikeList"
    />

    <div
      v-if="!errorFlag && !loading"
      class="estimate-result__note"
    >
      <ul>
        <li>※表示価格は、{{priceDate}}現在の情報です。</li>
        <li>※現金販売価格は消費税{{tax}}％込み価格です。</li>
        <li>※現金販売価格（リサイクル費用を含む）には保険料・税金（消費税を除く）・登録などに伴う諸費用は含まれておりません。</li>
        <li v-for="note in notes"><sup>*{{note.key}}</sup> {{note.note}}</li>
        <li>※一部の写真は海外仕様車も含まれます。</li>
      </ul>
    </div>

    <div
      class="estimate-loader"
      v-if="loading"
    >
      <span></span>
    </div>
  </section>
</template>

<script>
import {defineComponent, ref, computed} from 'vue'
import axios from 'axios'
import {Util} from './master.js'
import EstimateDisplacements from './estimate/EstimateDisplacement.vue'
import EstimateSearchListCategory from './estimate/EstimateSearchListCategory.vue'
import SearchLoaderParts from './parts/SearchLoaderParts.vue'

export default defineComponent({
  name: 'EstimateList',
  components: {
    EstimateDisplacements,
    EstimateSearchListCategory,
    SearchLoaderParts,
  },
  setup(props) {
    const
      loading = ref(true),
      selectDisplacement = ref(['50', '125', '250', '400', 'over']),
      bikeList = ref([]),
      notes = ref([]),
      errorFlag = ref(false),
      tax = ref(10), // 消費税
      priceDate = ref('') // 表示価格の日付


    const displacementBikesList = ref([
      { key: 'over', title: '401cc以上', list: [] },
      { key: '400', title: '251cc〜400cc', list: [] },
      { key: '250', title: '126cc〜250cc', list: [] },
      { key: '125', title: '51cc〜125cc', list: [] },
      { key: '50', title: '50cc以下', list: [] }
    ])

    // bikelistの中からselectDisplacementに含まれる排気量のみを抽出
    const filteredBikeList = computed(() => {
      displacementBikesList.value.forEach((displacement) => {
        displacement.list = bikeList.value.filter((bike) => {
          return selectDisplacement.value.includes(bike.product_type) && bike.product_type === displacement.key
        })
      })

      return displacementBikesList.value
    })

    return {
      errorFlag,
      loading,
      bikeList,
      notes,
      selectDisplacement,
      displacementBikesList,
      filteredBikeList,
      tax,
      priceDate
    }
  },
  async mounted() {
    // 一度localStorageに保存したデータを削除
    localStorage.removeItem('estimateResult')

    const json = JSON.parse(document.querySelector('[data-estimate-meta]').textContent)
    this.tax = json.tax
    this.priceDate = json['price_date']

    this.bikeList = await this.getListData()
    this.loading = false

  },
  methods: {
    /**
     * 車両データ取得
     */
    async getListData() {
      try {
        const response = await axios.get(Util.API.estimateList)
        this.notes = response.data.notes
        return response.data.products
      } catch (error) {
        console.error('エラーが発生しました:', error);
        this.errorFlag = true
        return  null
      }
    },
  }
})

</script>